<div class="py-5 mt-3">

  <div  *ngIf="!awardRequestTnx">
    <p class="text-center">Masz pomysł na nową nagrodę? Sprawdzimy, czy możemy dodać ją <br class="d-none d-md-block">do katalogu nagród.</p>
    <button *ngIf="!showForm" class="btn btn-dark d-block mx-auto" type="button" (click)="showForm = true">ZAPROPONUJ NAGRODĘ</button>

    <div *ngIf="showForm">
      <h2 class="text-center">Zaproponuj nagrodę</h2>
      <p class="text-center">
        Masz pomysł na urozmaicenie katalogu nagród? Przedstaw nam <br class="d-none d-md-block">swoją propozycję. Sprawdzimy, czy możemy ją dodać do katalogu<br class="d-none d-md-block"> nagród.
      </p>


      <form [formGroup]="form" (ngSubmit)="onSubmit()" style="max-width: 350px; margin:  0 auto;">

        <div class="form-group">
          <label for="name" class="label">
            Nazwa nagrody
          </label>
          <input type="name" formControlName="name" class="field" >
          <div class="errors">
            <small *ngIf="form.get('name').hasError('required')">Pole jest wymagane</small>
            <div *ngIf="form.get('name').hasError('backend')">
              <small *ngFor="let error of form.get('name').errors['backend'] | keyvalue">
                {{ error.value }}
              </small>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="link" class="label">
            Link do nagrody
          </label>
          <input type="link" formControlName="link" class="field" >
          <div class="errors">
            <small *ngIf="form.get('link').hasError('required')">Pole jest wymagane</small>
            <div *ngIf="form.get('link').hasError('backend')">
              <small *ngFor="let error of form.get('link').errors['backend'] | keyvalue">
                {{ error.value }}
              </small>
            </div>
          </div>
        </div>

        <button class="btn btn-dark d-block mx-auto mt-3" type="submit" [disabled]="submited">Wyślij</button>

      </form>

    </div>


  </div>

  <div class="text-center" *ngIf="awardRequestTnx">
    <h2>
      Dziękujemy!
      <br>
      Formularz zgłoszeniowy został wysłany.
    </h2>

    <p>Jeśli nagroda trafi do katalogu nagród, damy Ci znać w ciągu 48h od tego faktu.</p>
  </div>

</div>
